import React from 'react';
import { object, func, array, bool } from 'prop-types';
import { isEmpty, filter, includes } from 'lodash';
import moment from 'moment';
import { FlexContainer, Column, FormDatePicker, SalesChannelSelect, Button, FormSelect, CompanyGroupsSelect, FormInput } from '../../common';
import UserSearchSelect from '../Users/UserSearchSelect';
import { shopperStatus, thirdPartyCompanies } from '../../../utils/misc';

const Filters = ({
    userSalesChannel,
    sessionSalesChannel,
    onChangeDateRange,
    onChangeShopper,
    selectedShopper,
    onChangeSalesChannel,
    onChangeCompany,
    selectedCompany,
    onChangeStatus,
    selectedStatus,
    onChangeCompanyGroup,
    selectedCompanyGroup,
    salesChannelDefaultValue,
    onSubmit,
    onReset,
    onSubmitCallback,
    isMobile,
    rut,
    onChangeRut,
    selectedSplitUser,
    onChangeSplitUser    
}) => {
    const userSelectFilters = {
        filters: [
            {
                field: 'salesChannels',
                value: userSalesChannel
            },
            {
                field: 'statusUser',
                value: ['0']
            }
        ]
    };
    return (
        <FlexContainer>
            <Column
                padding={15}
            >
                <FormDatePicker
                    label='Fecha'
                    onChange={onChangeDateRange}
                    defaultValue={moment()}
                    limitDays={7}
                    width={isMobile ? '100%' : null}
                    mobile={isMobile}
                    position='fixed'
                    portalStyle={{ top: '205px' }}
                />
                <CompanyGroupsSelect onChange={onChangeCompanyGroup} sessionSalesChannel={sessionSalesChannel} initialValue={{ label: 'Jumbo', value: 'Jumbo' }} />
                <SalesChannelSelect
                    native
                    label='Tienda'
                    onChange={onChangeSalesChannel}
                    defaultValue={salesChannelDefaultValue}
                    customizeOptions={options => {
                        if (isEmpty(selectedCompanyGroup)) return options;
                        const filterOptions = filter(options, ({ kind }) => includes(selectedCompanyGroup, kind));
                        return filterOptions;
                    }}
                />
                <FormSelect
                    multiple
                    label='Empresa'
                    options={thirdPartyCompanies()}
                    value={selectedCompany}
                    onChange={onChangeCompany}
                />
                <FormSelect
                    multiple
                    label='Estado'
                    options={shopperStatus}
                    value={selectedStatus}
                    onChange={onChangeStatus}
                />
                <UserSearchSelect
                    label='Shopper'
                    filters={userSelectFilters}
                    value={selectedShopper}
                    onChange={onChangeShopper}
                    placeholder='Ingrese (nombre, apellido o email)'
                />
                <FormInput
                    label='Rut'
                    value={rut}
                    onChange={onChangeRut}
                    placeholder='Ingrese rut'
                />
                <FormSelect
                    label='Splitero'
                    options={[
                        { value: '0', label: 'No' },
                        { value: '1', label: 'Si' }
                    ]}
                    value={selectedSplitUser}
                    onChange={onChangeSplitUser}
                />
                <FlexContainer
                    align='flex-end'
                    mB={10}
                >
                    <Button
                        link
                        text='Limpiar'
                        onClick={onReset}
                    />
                    <Button
                        text='Buscar'
                        onClick={() => {
                            onSubmit();
                            if (onSubmitCallback) {
                                onSubmitCallback();
                            }
                        }}
                        // disabled={isEmpty(salesChannelDefaultValue)}
                    />
                </FlexContainer>
            </Column>
        </FlexContainer>
    );
};

Filters.propTypes = {
    userSalesChannel: object,
    sessionSalesChannel: array,
    onChangeDateRange: func,
    onChangeShopper: func,
    selectedShopper: object,
    onChangeSalesChannel: func,
    onChangeCompany: func,
    selectedCompany: object,
    onChangeStatus: func,
    selectedStatus: object,
    onChangeCompanyGroup: func,
    selectedCompanyGroup: object,
    salesChannelDefaultValue: object,
    onSubmit: func,
    onReset: func,
    onSubmitCallback: func,
    isMobile: bool
};

export default Filters;
